// Split out from use-item-permissions.hook.ts: use-kit-permissions.hook.ts needs these,
// and use-item-permissions.hook.ts needs canAdminKit from utils/kit-permissions.ts —
// keeping the shared checks here avoids a circular import between the two hook files.
import { usePermissions } from '../use-permissions.hook';

export const canTakeItemCustody = (permissions: ReturnType<typeof usePermissions>) => {
	const { useCustody, hasAnyPermission } = permissions;
	return useCustody && hasAnyPermission('ITEMS_CUSTODY_TAKER', 'ITEMS_CUSTODY_TAKER_RESTRICTED');
};

export const canTransferItemCustody = (permissions: ReturnType<typeof usePermissions>, own?: boolean) => {
	const { useCustody, hasAnyPermission } = permissions;
	return (
		useCustody &&
		(hasAnyPermission('ITEMS_CUSTODY_TRANSFERER', 'ITEMS_CUSTODY_TRANSFERER_RESTRICTED') ||
			(own && hasAnyPermission('ITEMS_CUSTODY_OWN_TRANSFERER')))
	);
};

export const canReleaseItemCustody = (permissions: ReturnType<typeof usePermissions>, own?: boolean) => {
	const { useCustody, hasAnyPermission } = permissions;
	return (
		useCustody &&
		(hasAnyPermission('ITEMS_CUSTODY_RELEASER', 'ITEMS_CUSTODY_RELEASER_RESTRICTED') ||
			(own && hasAnyPermission('ITEMS_CUSTODY_OWN_RELEASER')))
	);
};

export const canGiveItemCustody = (permissions: ReturnType<typeof usePermissions>, own?: boolean) => {
	const { hasAnyPermission } = permissions;
	return (
		hasAnyPermission('CUSTOMERS_READER') &&
		canTransferItemCustody(permissions, own) &&
		canTakeItemCustody(permissions)
	);
};

export const canAdminItem = (permissions: ReturnType<typeof usePermissions>) => {
	const { hasAnyPermission } = permissions;
	return hasAnyPermission('ITEMS_ADMIN', 'ITEMS_ADMIN_RESTRICTED');
};

export const canUpdateItemGeo = (permissions: ReturnType<typeof usePermissions>) => {
	const { useGeo, hasAnyPermission } = permissions;
	return useGeo && hasAnyPermission('ITEMS_GEO_ADMIN', 'ITEMS_GEO_ADMIN_RESTRICTED');
};
